export default function(){
    const countdown = document.querySelector('[data-name="countdown-new-house"]');

    if (countdown) {
        const days = countdown.querySelector('[data-name="days"]');
        const hours = countdown.querySelector('[data-name="hours"]');
        const minutes = countdown.querySelector('[data-name="mins"]');
        const seconds = countdown.querySelector('[data-name="secs"]');
        const countDownDate = new Date(Date.UTC(2025, 8, 4, 8, 0, 0)).getTime(); // Set the countdown date in UTC: 4th September 2025 08:00:00

        // Update the countdown every 1 second
        const interval = setInterval(function() {
            // Get today's date and time in UTC
            const now = new Date().getTime();

            // Find the distance between now and the countdown date
            const distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            const daysValue = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hoursValue = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutesValue = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const secondsValue = Math.floor((distance % (1000 * 60)) / 1000);

            // Output the result in the respective elements
            days.innerHTML = daysValue;
            hours.innerHTML = hoursValue;
            minutes.innerHTML = minutesValue;
            seconds.innerHTML = secondsValue;

            // If the countdown is over, stop the interval
            if (distance < 0) {
                clearInterval(interval);
                days.innerHTML = "0";
                hours.innerHTML = "0";
                minutes.innerHTML = "0";
                seconds.innerHTML = "0";
            }
        }, 1000);
    }
}